import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"

import { faCircleArrowDown, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Link, useNavigate } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import InfoIcon from "../../../InfoIcon"
import Filter from "./mobile/filter"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"

export default function MobileComponent() {


    const [mobileItems, setMobileItems] = useState()


    let filteredproducttypes = useSelector((state) => state.producttype.filteredProducttypes)

    let dispatch = useDispatch()



    let stateproducttypes = useSelector(state => state.producttype.producttypes)


    useEffect(() => {

        let items = []
        let producttypes = filteredproducttypes ?? stateproducttypes

        if (producttypes && Object.keys(producttypes).length > 0) {

            producttypes.forEach((producttype) => {

                items.push(<MobileItem key={producttype.id} producttype={producttype} />)

            })
        }
        setMobileItems(items)



    }, [filteredproducttypes, stateproducttypes])


    if (!mobileItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}


function MobileItem(props) {
    const { producttype } = props

    const [showContent, setShowContent] = useState(false)

    const { del } = useFetch()

    let dispatch = useDispatch()


    let navigate = useNavigate()

    return <Fragment>

        <div className="card shadow  bg-white rounded p-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowContent(!showContent)
        }}  >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }} >
                <span>{producttype.id}</span>
                <span>{producttype.title}</span>
                <span>{producttype.created_on}</span>
            </div>
            <InfoIcon icon={faCircleArrowDown} size='xl' />

        </div>
        {showContent &&
            <table className="table table-striped table-bordered" >
                <tbody>
                    <tr>
                        <th>ID</th>
                        <td>
                            {producttype.id}
                        </td>
                    </tr>
                    <tr>
                        <th>Title</th>

                        <td>
                            {producttype.title}
                        </td>
                    </tr>
                    <tr>
                        <th>CreatedOn</th>
                        <td>
                            {producttype.created_on}
                        </td>
                    </tr>
                    <tr>
                        <th>Edit</th>
                        <td>
                            <Link className="btn btn-outline-secondary bgnt" to={`/admin/producttypes/${producttype.id}`} ><InfoIcon icon={faEdit} title='producttype details' /></Link>
                        </td>

                    </tr>

                    <tr>
                        <th>Delete</th>
                        <td>
                            <button disabled={producttype.id === 1} type="button" className="btn btn-warning" onClick={() => {
                                del(`/admin/producttype`, { id: producttype.id }, (data) => {
                                    dispatch(notificationActions.setNotification({
                                        message: data,
                                        status: false
                                    }))
                                },
                                    (data) => {
                                        console.log(data)
                                        dispatch(notificationActions.setNotification({
                                            message: `producttype deleted`,
                                            status: true
                                        }))


                                        navigate('/admin/producttypes', {
                                            state: {
                                                refetch: true
                                            }
                                        })
                                    }
                                )
                            }} style={{ width: '100%' }} ><InfoIcon icon={faTrash} title='delete producttype' /></button>
                        </td>
                    </tr>

                </tbody>
            </table>
        }


    </Fragment>

}